import {getUserId} from './store'

export default getUserId



// WEBPACK FOOTER //
// ./src/App/helpers/meteor-apollo-accounts/userId.js